<template>
    <g>
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6ZM6.66667 3.33331C6.66667 2.96512 6.36819 2.66664 6 2.66664C5.63181 2.66664 5.33333 2.96512 5.33333 3.33331V5.99998C5.33333 6.36817 5.63181 6.66664 6 6.66664C6.36819 6.66664 6.66667 6.36817 6.66667 5.99998V3.33331ZM6 8.00002C5.63181 8.00002 5.33333 8.2985 5.33333 8.66669C5.33333 9.03488 5.63181 9.33336 6 9.33336H6.0064C6.37459 9.33336 6.67307 9.03488 6.67307 8.66669C6.67307 8.2985 6.37459 8.00002 6.0064 8.00002H6Z"
            fill="#C29500"
        />
    </g>
</template>
<script>
export default {
    name: "WarningCircle",
};
</script>
